import styled from "styled-components";

export const RoleItem = styled.span<{ $invalidGlobalRole?: boolean }>`
  white-space: nowrap;
  color: ${(p) =>
    p.$invalidGlobalRole ? p.theme.color.palette.tomatoRed : undefined};
`;

export const RolesContainer = styled.span`
  display: flex;
  flex-wrap: wrap;
  column-gap: 0.25rem;
`;
